import { LOCAL_STORAGE_KEY } from "constants/common.constant";
import { ROUTERS } from "constants/routes.constant";
import { TypeCommon } from "models/common";
import {
  Outlet,
  Navigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import { fetchTokens } from "utils/common.util";

export const PrivateRoutes = (): TypeCommon => {
  const location = useLocation();
  const pathname = location?.search
    ? `${location?.pathname}${location?.search}`
    : location?.pathname;
  const auth = localStorage.getItem(LOCAL_STORAGE_KEY.USER_INFO);
  if (location.pathname !== "/")
    return auth ? (
      <Outlet />
    ) : (
      <Navigate to={`${ROUTERS.LOGIN}?redirect=${pathname}`} />
    );
  return auth ? <Outlet /> : <Navigate to={ROUTERS.LOGIN} />;
};
export const UnLoggedRoutes = (): TypeCommon => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  if (code) {
    //gửi code để lấy token
    fetchTokens(code);
    return <Outlet />;
  }
  const userLogged =
    localStorage.getItem(LOCAL_STORAGE_KEY.USER_INFO) &&
    window.location.pathname !== ROUTERS.CONFIRM_CHANGE_EMAIL;
  if (userLogged && searchParams.get("redirect")) {
    return window.location.assign(searchParams.get("redirect") as TypeCommon);
  }
  return !userLogged ? (
    <Outlet />
  ) : (
    <Navigate to={ROUTERS.SERVICE_MANAGEMENT} />
  );
};
